"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionNote_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ConversionNote_Factory = /** @class */ (function () {
    function ConversionNote_Factory() {
    }
    ConversionNote_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Markup: model.Markup,
            NoteTitle: model.NoteTitle,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    ConversionNote_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Markup: model.Markup,
            NoteTitle: model.NoteTitle,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return ConversionNote_Factory;
}());
exports.ConversionNote_Factory = ConversionNote_Factory;
